<template>
  <div>
    <loading :active.sync="isLoading"
    :can-cancel="true"
    color="#5bad2b"
    :is-full-page="true"></loading>
    <div class="container maincontent">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="tab-content">
              <div class="active tab-pane" id="activity">
                <div class="row postdata">
                  <div style="margin-top:20px">
                    <div class="nav">
                      <div class="box-header">
                        <h3 class="box-title pageTitle fw-600">Profiles</h3>
                      </div>
                      <!-- <hr class="myline"> -->
                      <hr style="margin-top:2px; margin-bottom:6px" />
                      <div class="row postArea" v-if="postData != null">
                        <div class="col-md-5 p-1">
                          <div class="candidateArea">
                            <div class="Orgimage1">
                              <!-- <img class="round" v-if="postData.org_logo !='' && postData.org_logo !=null" :src="`${postData.org_logo}`">
                              <img class="round" v-if="postData.org_logo =='' || postData.org_logo ==null" src="../assets/img/default.png"> -->
                              <img v-if="userInfo.profile_pic ==null || userInfo.profile_pic ==''" class="round" src="../assets/img/default.png">
                              <img class="round" v-if="userInfo.profile_pic !=null && userInfo.profile_pic !=''" :src="`${userInfo.profile_pic}`">
                            </div>
                            <div class=" candidateDetails col-md-12">
                              <span class="canName">
                                {{postData.job_title}}
                                <i
                                  v-if="postData.expired ==true"
                                  class="fa fa-circle"
                                  style="color:red; font-size:10px"
                                  aria-hidden="true"
                                ></i>
                                <i
                                  v-else
                                  class="fa fa-circle"
                                  style="color:#5bad2b; font-size:10px"
                                  aria-hidden="true"
                                ></i>
                              </span>
                              <br />
                              <span>{{postData.unique_id}}</span>
                              <br />
                              <!-- <span>9677696198</span> -->
                              <span class="overflow" >
                                <span :title="postData.primarySkillName" class="skill-lable">Skills :</span>
                                {{postData.primarySkillName}}
                              </span>
                            </div>
                            <!-- <div class="col-md-11 p-1">
                              <div class="mt-2"></div>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-md-7 p-1">
                          <div class="row" v-if="this.$route.params.post_type=='jd'">
                            <div class="col-md-3 p-1 countcard" style="text-align:center" >
                              <a class="" @click="status=''; score=''; sit=''; shortListed = false; selectedSt=''; candidateList()">
                                <div :style="status_type=='candidate'?'font-weight:bold; color:#5bad2b':''" class="countStyle">{{metrix.relevant}}</div>
                                <div :style="status_type=='candidate'?'font-weight:bold; color:#5bad2b':''" class="countSpecificationStyle">
                                  Profiles
                                </div>
                              </a>
                            </div>
                            <div v-if="this.$route.params.post_type=='jd'" class="col-md-3 p-1" style="text-align:center">
                              <a @click="score=''; status=''; selectedSt=''; sit=''; shortListed = true; candidateList('shortlist')">
                                <div class="countStyle" :style="status_type=='shortlist'?'font-weight:bold; color:#5bad2b':''">{{metrix.shortlisted}}</div>
                                <div class="countSpecificationStyle" :style="status_type=='shortlist' ?'font-weight:bold; color:#5bad2b':''">Shortlisted</div>
                              </a>
                            </div>
                            <div class="col-md-3 p-1" style="text-align:center">
                              <a @click="score=''; sit=''; selectedSt=''; shortListed = false; status=='Scheduled' ? status='' : status='Scheduled'; candidateList('scheduled')">
                                <div class="countStyle" :style="status_type=='scheduled'?'font-weight:bold; color:#5bad2b':''">{{metrix.scheduled}}</div>
                                <div class="countSpecificationStyle" :style="status_type=='scheduled'?'font-weight:bold; color:#5bad2b':''">
                                  Scheduled
                                </div>
                              </a>
                            </div>
                            <div class="col-md-3 p-1" style="text-align:center">
                              <a @click="score=''; sit='';status=''; selectedSt=='Yes'? selectedSt='' : selectedSt='Yes'; candidateList('select')">
                                <div class="countStyle" :style="status_type=='select'?'font-weight:bold; color:#5bad2b':''">{{metrix.selected}}</div>
                                <div class="countSpecificationStyle" :style="status_type=='select'?'font-weight:bold; color:#5bad2b':''">
                                  Selected
                                </div>
                              </a>
                            </div>
                          </div>
                          <div class="row" v-if="this.$route.params.post_type=='id'">
                            <div class="col-md-3 p-1 countcard" style="text-align:center" >
                              <a class="" @click="status=''; sit6 = ''; score=''; status_type='candidate'; getPostDetailsId()">
                                <div :style="status_type=='candidate'?'font-weight:bold; color:#5bad2b':''" class="countStyle">{{postDataID.profiles}}</div>
                                <div :style="status_type=='candidate'?'font-weight:bold; color:#5bad2b':''" class="countSpecificationStyle">
                                  Profiles
                                </div>
                              </a>
                            </div>
                            <div class="col-md-3 p-1" style="text-align:center">
                              <a @click="score=''; sit6 = ''; status='Scheduled'; status_type='scheduled'; getPostDetailsId()">
                                <div class="countStyle" :style="status_type=='scheduled'?'font-weight:bold; color:#5bad2b':''">{{postDataID.scheduled}}</div>
                                <div class="countSpecificationStyle" :style="status_type=='scheduled'?'font-weight:bold; color:#5bad2b':''">
                                  Scheduled
                                </div>
                              </a>
                            </div>
                            <div class="col-md-3 p-1" style="text-align:center">
                              <a @click="score=''; sit6 = 'true'; status=''; status_type='sit'; getPostDetailsId()">
                                <div class="countStyle" :style="status_type=='sit'?'font-weight:bold; color:#5bad2b':''">{{postDataID.sit_score_morethan_6}}</div>
                                <div class="countSpecificationStyle" :style="status_type=='sit'?'font-weight:bold; color:#5bad2b':''">SIT>6</div>
                              </a>
                            </div>
                            <div class="col-md-3 p-1" style="text-align:center">
                              <a @click="score=''; sit6 = ''; status='Selected'; status_type='select'; getPostDetailsId()">
                                <div class="countStyle" :style="status_type=='select'?'font-weight:bold; color:#5bad2b':''">{{postDataID.selected}}</div>
                                <div class="countSpecificationStyle" :style="status_type=='select'?'font-weight:bold; color:#5bad2b':''">
                                  Selected
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="myIcons">
                        <div class="icon1" @click="selectInterviewer('Tech')" v-if="this.$route.params.post_type === 'id'">
                          <i class="fa fa-user-o" aria-hidden="true"></i>
                          <span class="badge badge-light">{{postDataID.r_interviewer}}</span>
                          <br />
                          <span class="iconName">Select Interviewers</span>
                        </div>
                        <div class="dropdown notifications-menu" v-if="this.$route.params.post_type === 'jd'">
                            <a class="dropdown-toggle" data-toggle="dropdown">
                              <div class="icon1">
                                <i class="fa fa-user-o" aria-hidden="true"></i>
                                <span class="badge badge-light">{{interviewerCount}}</span>
                                <br />
                                <span class="iconName">Select Interviewers</span>
                              </div>
                            </a>
                              <!-- @click="selectInterviewer()" -->
                            <div class="dropdown-menu logmenu" style="width: 210px;">
                              <div>
                                <div class="menu" @click="selectInterviewer('Tech')">
                                    <a>Technical</a>
                                </div>
                                <div class="menu" @click="selectInterviewer('HR')">
                                    <a>HR</a>
                                </div>
                              </div>
                            </div>
                        </div>
                        <div
                          v-if="this.$route.params.post_type === 'id'"
                          class="icon2"
                          data-toggle="modal"
                          data-target="#uploadResume" @click="resumefiles = []"
                        >
                          <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                          <br />
                          <span class="iconName">Upload Resume</span>
                        </div>
                      </div>
                      <div class="col-md-3 filterBoxBorder">
                        <!-- <div class="card">
                          <div>Filter By</div>
                        </div> -->
                        <div class="box box-primary">
                          <div class="box-header with-border filterbyClass">
                            <h3 class="box-title">Filter By</h3>
                            <div class="box-tools pull-right">
                              <button
                                type="button"
                                @click="clearFilter"
                                class="btn btn-box-tool btncolorClass"
                              >
                                <b>Clear</b>
                              </button>
                            </div>
                          </div>
                          <div class="box-body">
                            <ul class="filterTopclass">
                              <li v-if="this.$route.params.post_type === 'id'" class="filterListclass">
                                <div>
                                  <a href="#" class="">Status</a>
                                </div>
                                <div class="filterDivclass form-group">
                                  <div class="form-select">
                                    <select
                                      class="form-control"
                                      style="height:30px"
                                      placeholder="Select Status"
                                      v-model="status"
                                      @change="getPostDetailsId"
                                    >
                                      <option value="" selected
                                        >Select Status</option
                                      >
                                      <option value="New">New</option>
                                      <option value="Schedule Initiated">Schedule Request Pending</option>
                                      <option value="Scheduled"
                                        >Scheduled</option
                                      >
                                      <option value="Cancelled">Open</option>
                                      <option value="Reschedule Initiated">Re-schedule Request pending</option>
                                      <option value="Re-Scheduled">Re-Scheduled</option>
                                      <option value="Completed">Completed</option>
                                      <!-- <option value="Incomplete">Incomplete</option> -->
                                      <option value="Selected">Selected</option>
                                      <option value="Rejected">Rejected</option>
                                    </select>
                                    <span class="select-icon"
                                      ><i class="fa fa-chevron-down"></i
                                    ></span>
                                  </div>
                                </div>
                              </li>
                              <li v-if="this.$route.params.post_type === 'id'" class="filterListclass">
                                <div>
                                  <a href="#" class="">Score</a>
                                  <!-- <span class="pull-right"><i class="" v-bind:class="{ 'fa fa-angle-up' : activeFilter == 'score', 'fa fa-angle-down' : activeFilter != 'score' }"></i></span> -->
                                </div>
                                <div class="filterDivclass  form-group">
                                  <div class="form-select">
                                    <select
                                      class="form-control"
                                      placeholder="Select Score"
                                      style="height:30px"
                                      v-model="score"
                                      @change="getPostDetailsId"
                                    >
                                      <option value="" selected
                                        >Select Score</option
                                      >
                                      <option value="0">0</option>
                                      <option
                                        :value="n"
                                        v-for="n in 10"
                                        :key="n"
                                        >{{ n }}</option
                                      >
                                    </select>
                                    <span class="select-icon"
                                      ><i class="fa fa-chevron-down"></i
                                    ></span>
                                  </div>
                                </div>
                              </li>
                              <li v-if="this.$route.params.post_type === 'jd'" class="filterListclass">
                                <div>
                                  <a href="#" class="">Score</a>
                                </div>
                                <div class="filterDivclass  form-group">
                                  <div class="form-select">
                                    <select
                                      class="form-control"
                                      placeholder="Select Score"
                                      style="height:30px"
                                      v-model="score"
                                      @change="candidateList(status_type)"
                                    >
                                      <option value="" selected
                                        >Select Score</option
                                      >
                                      <option value="6"> >=6</option>
                                      <option value="7"> >=7</option>
                                      <option value="8"> >=8</option>
                                      <option value="9"> >=9</option>
                                      <option value="10"> 10</option>
                                    </select>
                                    <span class="select-icon"
                                      ><i class="fa fa-chevron-down"></i
                                    ></span>
                                  </div>
                                </div>
                              </li>
                              <!-- <li class="filterListclass" v-if="status_type == 'candidate'" >
                                <div>
                                  <a href="#" class="">Applied</a>
                                </div>
                                <div class="filterDivclass  form-group">
                                  <div class="form-select">
                                    <select
                                      class="form-control"
                                      placeholder="Select Score"
                                      style="height:30px"
                                      v-model="score"
                                      @change="candidateList"
                                    >
                                      <option value="" selected
                                        >Select Status</option
                                      >
                                      <option value="yes">Yes</option>
                                      <option value="no">No</option>
                                    </select>
                                    <span class="select-icon"
                                      ><i class="fa fa-chevron-down"></i
                                    ></span>
                                  </div>
                                </div>
                              </li> -->
                              <li v-if="this.$route.params.post_type === 'id'" class="filterListclass">
                                <div>
                                  <a href="#" class="">Date</a>
                                  <div class="box-tools pull-right">
                                    <button
                                      type="button"
                                      @click="getPostDetailsId"
                                      class="btn btn-box-tool btncolorClass"
                                    >
                                      <b>Apply</b>
                                    </button>
                                  </div>
                                </div>
                                <div class="filterDivclass">
                                  <div>
                                    <datetime
                                      v-model="fromdate"
                                      format="dd-MMM-yyyy"
                                      type="date"
                                      placeholder="Select From Date"
                                      @keyup="getPostDetailsId"
                                    >
                                    </datetime>
                                    <br />
                                    <datetime
                                      v-model="todate"
                                      format="dd-MMM-yyyy"
                                      type="date"
                                      placeholder="Select To Date"
                                      @keyup="getPostDetailsId"
                                    >
                                    </datetime>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-9" >
                        <div class="row">
                        <div class="filterdata">
                          <div v-if="this.$route.params.post_type === 'jd'" class="searchinput">
                            <input v-model="postsearch" type="text" class=" search-text"  placeholder="Search.." >
                            <span v-if="postsearch != ''" @click="postsearch=''; candidateList(status_type)"><i class="fa fa-times"></i></span>
                            <button @click="candidateList(status_type)"><i class="fa fa-search"></i></button>
                          </div>
                          <div v-if="this.$route.params.post_type === 'id'" class="searchinput">
                            <input v-model="postsearch" type="text" class=" search-text"  placeholder="Search.." >
                            <span v-if="postsearch != ''" @click="postsearch=''; getPostDetailsId()"><i class="fa fa-times"></i></span>
                            <button @click="getPostDetailsId()"><i class="fa fa-search"></i></button>
                          </div>
                        </div>
                        <div class="text-center">
                          <div class="box-body" v-if="this.$route.params.post_type === 'jd'">
                            <ul v-if="status_type != 'scheduled' && status_type != 'select'" style="list-style:none" class="profileClass">
                              <div v-if="candidateListing.length == 0" class="text-muted tc" style="margin-top: 20%;">No data found</div>
                              <li v-for="(mydata, indexx) in candidateListing" :key="indexx">
                                <div class="postArea1 col-mod-12">
                                  <div class="candidateArea col-mod-7" style="text-align:start">
                                    <div class="Orgimage1">
                                      <a href="#">
                                        <img class="round" v-if="mydata.profile_pic !='' && mydata.profile_pic !=null" :src="`${mydata.profile_pic}`">
                                        <img class="round" v-else src="../assets/img/default.png">
                                      </a>
                                    </div>
                                    <div class="abc" >
                                      <a class="candidateDetails overflow">
                                        <span :title="mydata.first_name + ' ' + mydata.last_name" class="canName" >{{mydata.first_name}}</span>
                                        <br />
                                        <span><span style="font-size: 12px; font-weight:bold; color: grey;">Designation : </span ><span style="font-size: 12px; font-weight:bold; color: black;" :title="mydata.designation">{{(mydata.designation == '' || mydata.designation == null || mydata.designation == undefined) ? 'NA' : mydata.designation }}</span></span>
                                        <br />
                                        <span><span style="font-size: 12px; font-weight:bold; color: grey;">Experience : </span><span style="font-size: 12px; font-weight:bold; color: black;" v-if="mydata.year_of_experience > 0">{{mydata.year_of_experience}} Year <span style="font-size: 12px; font-weight:bold; color: black;" v-if="mydata.month_of_experience > 0"> {{ mydata.month_of_experience }} Month</span></span>
                                        <span style="font-size: 12px; font-weight:bold; color: black;" v-if="mydata.year_of_experience == 0">{{"Fresher"}}</span></span>
                                      </a>
                                    </div>
                                  </div>
                                  <div class="status col-mod-2">
                                    <span v-if="status_type == 'candidate'" @click="openFeedBack(mydata.id)">
                                      <a style="color:#5bad2b; font-size: 18px; font-weight:bold;">{{ 'SIT ' + mydata.sit_score }}</a>
                                    </span>
                                    <span v-if="status_type == 'shortlist' && mydata.schedule.length != 0" @click="openFeedBack(mydata.id)">
                                      <a style="color:#5bad2b; font-size: 18px; font-weight:bold;">{{ 'SIT ' + mydata.sit_score }}</a>
                                    </span>
                                    <span v-if="status_type == 'shortlist' && mydata.schedule.length == 0" @click="openFeedBackIaas(mydata.id)">
                                      <a style="color:#5bad2b; font-size: 18px; font-weight:bold;">{{ 'SIT ' + mydata.sit_score }}</a>
                                    </span><br>
                                    <div v-if="status_type == 'shortlist'">
                                      <span data-toggle="modal" data-target="#showInterviewersListModal"  v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Reschedule Initiated' && mydata.schedule[0].sub_status == 'Accepted'"  @click="showPanels(mydata.schedule[0].id)">
                                        <a style="color:orange; font-size: 14px; font-weight:bold;">Re-Schedule Request Pending</a>
                                      </span>
                                    </div>
                                    <div v-if="status_type == 'shortlist'">
                                      <span data-toggle="modal" data-target="#showInterviewersListModal" v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Accepted'"  @click="showPanels(mydata.schedule[0].id)">
                                        <a style="color:orange; font-size: 14px; font-weight:bold;">Schedule Request Pending</a>
                                      </span>
                                    </div>
                                    <div v-if="status_type == 'shortlist'">
                                      <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Shortlisted' && mydata.schedule[0].sub_status == 'Shortlist Initiated'">
                                        <a style="color:red; font-size: 14px; font-weight:bold;">Confirmation Pending </a>
                                      </span>
                                    </div>
                                    <div v-if="status_type == 'shortlist'">
                                      <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Schedule Initiated'">
                                        <a style="color:blue; font-size: 14px; font-weight:bold;">Schedule Initiated </a>
                                      </span>
                                    </div>
                                    <div v-if="status_type == 'shortlist'">
                                      <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule ReInitiated' && (mydata.schedule[0].sub_status == 'Schedule Initiated' || mydata.schedule[0].sub_status == 'Reschedule Initiated')">
                                        <a style="color:blue; font-size: 14px; font-weight:bold;">Schedule ReInitiated </a><br>
                                        <a style="color:grey; font-size: 12px;">Selected Panelists Unavailable </a>
                                      </span>
                                    </div>
                                    <div v-if="status_type == 'shortlist'">
                                      <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Reschedule Initiated' && mydata.schedule[0].sub_status == 'Reschedule Initiated'">
                                        <a style="color:blue; font-size: 14px; font-weight:bold;">Reschedule Initiated </a>
                                      </span>
                                    </div>
                                    <div v-if="status_type == 'shortlist'">
                                      <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Reschedule Initiated'">
                                        <a style="color:blue; font-size: 14px; font-weight:bold;">Reschedule Initiated </a>
                                      </span>
                                    </div>
                                  </div>
                                  <div class="availability1 col-mod-3">
                                    <div class="d-flex flex-column" v-if="status_type == 'candidate'">
                                      <div>
                                        <button
                                        :disabled="postData.expired"
                                          @click="selectone(mydata); shortlistCandidate(mydata.id); "
                                          v-if="mydata.shortlisted!='Yes'"
                                          class="btn btn-success btn-sm pull-right"
                                        >{{'Shortlist'}}</button>
                                        <button
                                        :disabled="postData.expired"
                                          v-if="mydata.shortlisted=='Yes'"
                                          class="fa fa-check-circle fa-2x isSelected pull-right"
                                        ></button>
                                      </div>
                                      <div v-if="mydata.Applied != false" style="color:blue; font-size: 12px; font-weight:bold; margin-top:40px;">Applied</div>
                                    </div>
                                    <div v-if="status_type == 'shortlist'">
                                      <div v-if="(mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Accepted') ||
                                          (mydata.schedule.length != 0 && mydata.schedule[0].status == 'Reschedule Initiated' && mydata.schedule[0].sub_status == 'Accepted')"
                                          class="validity">
                                          <div style="font-weight:bold">{{ getDate(mydata.schedule[0].utc_starttime)}}</div>
                                          <div>{{ getTime(mydata.schedule[0].utc_starttime) }} to {{ getEndTime(mydata.schedule[0].utc_starttime) }}</div>
                                      </div>
                                      <span><a :disabled="postData.expired" v-if="mydata.schedule.length != 0 && mydata.schedule[0].status != 'Schedule Initiated' && mydata.schedule[0].status == 'Shortlisted' && mydata.schedule[0].sub_status != 'Rejected'" @click="removeShortList(mydata.id)" style="color:red; margin-top:2px;"><i class="fa fa-times" aria-hidden="true"></i> Remove </a></span>&nbsp;&nbsp;
                                      <span><a :disabled="postData.expired" v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Shortlisted' && mydata.schedule[0].sub_status == 'Rejected'" style="color:#eb5c3b; margin-top:2px;">Declined &nbsp;&nbsp;&nbsp;&nbsp;</a></span>
                                      <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status != 'Schedule Initiated' && mydata.schedule[0].status == 'Shortlisted' && mydata.schedule[0].sub_status == 'Accepted'" class="dropdown notifications-menu">
                                        <a :disabled="postData.expired" style="color:blue" class="dropdown-toggle pull-right" data-toggle="dropdown">
                                          Schedule
                                        </a>
                                        <div class="dropdown-menu logmenu" style="width: 210px;">
                                          <div>
                                            <div class="menu" @click="setAvailabilityRequest(mydata.schedule[0].id, 'Tech')">
                                                <a>Technical</a>
                                            </div>
                                            <div class="menu" @click="setAvailabilityRequest(mydata.schedule[0].id, 'HR')">
                                                <a>HR</a>
                                            </div>
                                          </div>
                                        </div>
                                      </span>
                                      <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Reschedule Initiated' && mydata.schedule[0].sub_status == 'Accepted'" class="dropdown notifications-menu">
                                        <a :disabled="postData.expired" style="color:#5bad2b" class="dropdown-toggle pull-right" data-toggle="dropdown">
                                          Set Availability
                                        </a>
                                        <div class="dropdown-menu logmenu" style="width: 210px;">
                                          <div>
                                            <div class="menu" @click="setAvailabilityRequest(mydata.schedule[0].id, 'Tech')">
                                                <a>Technical</a>
                                            </div>
                                            <div class="menu" @click="setAvailabilityRequest(mydata.schedule[0].id, 'HR')">
                                                <a>HR</a>
                                            </div>
                                          </div>
                                        </div>
                                        <a :disabled="postData.expired" style="color:blue" @click="scheduleAvailabilityJD(mydata.schedule[0].id)">
                                          Schedule &nbsp;
                                        </a>
                                      </span>
                                      <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Accepted'" >
                                        <span class="dropdown notifications-menu" >
                                          <a :disabled="postData.expired" style="color:#5bad2b" class="dropdown-toggle pull-right" data-toggle="dropdown">
                                            Set Availability
                                          </a>
                                          <!-- <a :disabled="postData.expired" class="dropdown-toggle" data-toggle="dropdown">
                                            <button class="btn btn-sm btn btn-primary pull-right" >
                                              Set Availability
                                            </button>
                                          </a> -->
                                          <div class="dropdown-menu logmenu" style="width: 210px;">
                                            <div>
                                              <div class="menu" @click="setAvailabilityRequest(mydata.schedule[0].id, 'Tech')">
                                                  <a>Technical</a>
                                              </div>
                                              <div class="menu" @click="setAvailabilityRequest(mydata.schedule[0].id, 'HR')">
                                                  <a>HR</a>
                                              </div>
                                            </div>
                                          </div>
                                        </span>
                                        <a :disabled="postData.expired" style="color:blue" @click="scheduleAvailabilityJD(mydata.schedule[0].id)">
                                          Schedule &nbsp;
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                            <ul v-if="status_type == 'scheduled'" style="list-style:none" class="profileClass">
                              <div v-if="candidateListing.length == 0" class="text-muted tc" style="margin-top: 20%;">No data found</div>
                              <li v-for="(mydata, indexx) in candidateListing" :key="indexx">
                                <div class="postArea1 col-mod-12" >
                                  <div class="candidateArea col-mod-7" style="text-align:start">
                                    <div class="Orgimage1">
                                      <a href="#">
                                        <img class="round" v-if="mydata.profile_pic !='' && mydata.profile_pic !=null" :src="`${mydata.profile_pic}`">
                                        <img class="round" v-else src="../assets/img/default.png">
                                      </a>
                                    </div>
                                    <div class="abc" >
                                      <a class="candidateDetails overflow">
                                        <span :title="mydata.first_name" class="canName" >{{mydata.first_name}}</span>
                                        <br />
                                        <span><span style="font-size: 12px; font-weight:bold; color: grey;">Designation : </span ><span style="font-size: 12px; font-weight:bold; color: black;" :title="mydata.designation">{{(mydata.designation == '' || mydata.designation == null || mydata.designation == undefined) ? 'NA' : mydata.designation }}</span></span>
                                        <br />
                                        <span><span style="font-size: 12px; font-weight:bold; color: grey;">Experience : </span><span style="font-size: 12px; font-weight:bold; color: black;" v-if="mydata.year_of_experience > 0">{{mydata.year_of_experience}} Year <span style="font-size: 12px; font-weight:bold; color: black;" v-if="mydata.month_of_experience > 0"> {{ mydata.month_of_experience }} Month</span></span>
                                        <span style="font-size: 12px; font-weight:bold; color: black;" v-if="mydata.year_of_experience == 0">{{"Fresher"}}</span></span>
                                      </a>
                                    </div>
                                  </div>
                                  <div class="status col-mod-2">
                                    <span v-if="mydata.schedule[0].feedback.length != 0" @click="openFeedBack1(mydata.schedule[0].feedback[0].schedule_id)">
                                      <a style="color:#5bad2b; font-size: 18px; font-weight:bold;">{{ 'SIT ' + mydata.schedule[0].feedback[0].sit_score }}</a>
                                    </span>
                                    <span v-else-if="mydata.schedule.length > 1 && mydata.schedule[1].feedback.length != 0" @click="openFeedBack1(mydata.schedule[1].feedback[0].schedule_id)">
                                      <a style="color:#5bad2b; font-size: 18px; font-weight:bold;">{{ 'SIT ' + mydata.schedule[1].feedback[0].sit_score }}</a>
                                    </span>
                                    <span v-else @click="openFeedBack(mydata.id)">
                                      <a style="color:#5bad2b; font-size: 18px; font-weight:bold;">{{ 'SIT ' + mydata.sit_score }}</a>
                                    </span><br>
                                    <div v-if="status_type == 'scheduled'">
                                      <span @click="showShedule1(mydata)" v-if="mydata.schedule[0].status=='Scheduled'">
                                        <a style="color:blue; font-size: 14px; font-weight:bold;">Scheduled</a>
                                      </span>
                                      <span @click="showShedule1(mydata)" v-if="mydata.schedule[0].status=='Rescheduled'">
                                        <a style="color:blue; font-size: 14px; font-weight:bold;">Rescheduled</a>
                                      </span>
                                      <span v-if="mydata.schedule[0].status=='Completed' && mydata.schedule[0].feedback_status=='pending'" @click="showResult1(mydata)">
                                        <a style="color:red; font-size: 14px; font-weight:bold;">Feedback Pending</a>
                                      </span>
                                      <span v-if="mydata.schedule[0].status=='Completed' && mydata.schedule[0].feedback_status=='Completed'">
                                        <a style="color:green; font-size: 14px; font-weight:bold;">Completed</a>
                                      </span>
                                      <span v-if="mydata.schedule[0].status=='Cancelled'" class="direct-chat-timestamp" style="color:red;cursor:pointer;font-weight:bold">
                                        Cancelled
                                      </span>
                                      <div>
                                        <a style="color:grey; font-size: 12px; font-weight:bold;" @click="viewHistory(mydata.id)"><i class="fa fa-tags" aria-hidden="true"></i> View History </a>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="availability1 col-mod-3">
                                    <div v-if="status_type == 'scheduled' && mydata.schedule[0].status=='Scheduled'">
                                      <div class="validity">
                                        <div style="font-weight:bold">{{ getDate(mydata.schedule[0].utc_starttime)}}</div>
                                        <div>{{ getTime(mydata.schedule[0].utc_starttime) }} to {{ getEndTime(mydata.schedule[0].utc_starttime) }}</div>
                                      </div>
                                      <div :disabled="postData.expired" class="d-flex flex-row">
                                        <a :disabled="postData.expired" style="color:red; font-size: 12px; font-weight:bold;" @click="showReason1(mydata.schedule[0].id)"><i class="fa fa-times" aria-hidden="true"></i> Cancel</a>&nbsp;&nbsp;
                                        <button style="color:blue" class="btn connectbtn btn-sm" :disabled="checkingdate(mydata.schedule[0].utc_starttime, mydata.schedule[0].utc_starttime) == 'no'"  @click="connect(mydata.schedule[0].meeting_id,mydata.schedule[0].id,mydata.schedule[0].user_id, mydata.schedule[0])">
                                          Connect
                                        </button>
                                      </div>
                                    </div>
                                    <div v-if="status_type == 'scheduled' && mydata.schedule[0].status=='Rescheduled'">
                                      <div class="validity">
                                        <div style="font-weight:bold">{{ getDate(mydata.schedule[0].utc_starttime)}}</div>
                                        <div>{{ getTime(mydata.schedule[0].utc_starttime) }} to {{ getEndTime(mydata.schedule[0].utc_starttime) }}</div>
                                      </div>
                                      <div :disabled="postData.expired" class="d-flex flex-row">
                                        <a :disabled="postData.expired" style="color:red; font-size: 12px; font-weight:bold;" @click="showReason1(mydata.schedule[0].id)"><i class="fa fa-times" aria-hidden="true"></i> Cancel</a>&nbsp;&nbsp;
                                        <button style="color:blue" class="btn connectbtn btn-sm" :disabled="checkingdate(mydata.schedule[0].utc_starttime, mydata.schedule[0].utc_starttime) == 'no'"  @click="connect(mydata.schedule[0].meeting_id,mydata.schedule[0].id,mydata.schedule[0].user_id, mydata.schedule[0])">
                                          Connect
                                        </button>
                                      </div>
                                    </div>
                                    <div v-if="status_type == 'scheduled' && mydata.schedule[0].status=='Completed' && mydata.schedule[0].feedback_status=='pending'">
                                      <div class="validity">
                                        <div style="font-weight:bold">{{ getDate(mydata.schedule[0].utc_starttime)}}</div>
                                        <div>{{ getTime(mydata.schedule[0].utc_starttime) }} to {{ getEndTime(mydata.schedule[0].utc_starttime) }}</div>
                                      </div>
                                    </div>
                                    <div v-if="status_type == 'scheduled' && mydata.schedule[0].status=='Completed' && mydata.schedule[0].feedback_status=='Completed'">
                                      <span class="dropdown notifications-menu">
                                        <a :disabled="postData.expired" style="color:blue" class="dropdown-toggle" data-toggle="dropdown">
                                          Schedule
                                        </a>
                                        <div class="dropdown-menu logmenu" style="width: 210px;">
                                          <div>
                                            <div class="menu" @click="setAvailabilityRequest(mydata.schedule[0].id, 'Tech')">
                                                <a>Technical</a>
                                            </div>
                                            <div class="menu" @click="setAvailabilityRequest(mydata.schedule[0].id, 'HR')">
                                                <a>HR</a>
                                            </div>
                                          </div>
                                        </div>
                                      </span>
                                      <br>
                                      <div style="margin-top:5px">
                                        <span :disabled="postData.expired" class="direct-chat-timestamp" style="color:red;cursor:pointer;" @click="selectModal(mydata.schedule[0].id, 'rejected')"><i class="fa fa-times" aria-hidden="true"></i>
                                            Reject
                                        </span>&nbsp;
                                        <span :disabled="postData.expired" class="direct-chat-timestamp" style="color:green;cursor:pointer;" @click="selectModal(mydata.schedule[0].id, 'selected')">
                                          <i class="fa fa-check" aria-hidden="true"></i> Select
                                        </span>&nbsp;
                                      </div>
                                    </div>
                                    <div v-if="status_type == 'scheduled' && mydata.schedule[0].status=='Rejected'">
                                      <span class="direct-chat-timestamp" style="color:red;cursor:pointer;">
                                        Rejected
                                      </span>
                                    </div>
                                    <div v-if="status_type == 'scheduled' && mydata.schedule[0].status=='Cancelled'">
                                      <!-- <span class="direct-chat-timestamp" style="color:red;cursor:pointer;font-weight:bold">
                                        Cancelled
                                      </span> &nbsp; -->
                                      <span class="dropdown notifications-menu">
                                        <a :disabled="postData.expired" style="color:#5bad2b" class="dropdown-toggle pull-right" data-toggle="dropdown">
                                          Re-Schedule
                                        </a>
                                        <div class="dropdown-menu logmenu" style="width: 210px;">
                                          <div>
                                            <div class="menu" @click="setAvailabilityRequestResch(mydata.schedule[0].id, 'Tech')">
                                                <a>Technical</a>
                                            </div>
                                            <div class="menu" @click="setAvailabilityRequestResch(mydata.schedule[0].id, 'HR')">
                                                <a>HR</a>
                                            </div>
                                          </div>
                                          <!-- <div>
                                            <div class="menu" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSets(mydata.schedule[0])">
                                                <a>Technical</a>
                                            </div>
                                            <div class="menu" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSets(mydata.schedule[0])">
                                                <a>HR</a>
                                            </div>
                                          </div> -->
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                            <ul v-if="status_type == 'select'" style="list-style:none" class="profileClass">
                              <div v-if="candidateListing.length === 0" class="text-muted tc" style="margin-top: 20%;">No data found</div>
                              <li v-for="(mydata, indexx) in candidateListing" :key="indexx">
                                <div class="postArea1 col-mod-12" >
                                  <div class="candidateArea col-mod-7" style="text-align:start">
                                    <div class="Orgimage1">
                                      <a href="#">
                                        <img class="round" v-if="mydata.profile_pic !='' && mydata.profile_pic !=null" :src="`${mydata.profile_pic}`">
                                        <img class="round" v-else src="../assets/img/default.png">
                                      </a>
                                    </div>
                                    <div class="abc" >
                                      <a class="candidateDetails overflow">
                                        <span :title="mydata.first_name" class="canName" >{{mydata.first_name}}</span>
                                        <br />
                                        <span><span style="font-size: 12px; font-weight:bold; color: grey;">Designation : </span ><span style="font-size: 12px; font-weight:bold; color: black;" :title="mydata.designation">{{(mydata.designation == '' || mydata.designation == null || mydata.designation == undefined) ? 'NA' : mydata.designation }}</span></span>
                                        <br />
                                        <span><span style="font-size: 12px; font-weight:bold; color: grey;">Experience : </span><span style="font-size: 12px; font-weight:bold; color: black;" v-if="mydata.year_of_experience > 0">{{mydata.year_of_experience}} Year <span style="font-size: 12px; font-weight:bold; color: black;" v-if="mydata.month_of_experience > 0"> {{ mydata.month_of_experience }} Month</span></span>
                                        <span style="font-size: 12px; font-weight:bold; color: black;" v-if="mydata.year_of_experience == 0">{{"Fresher"}}</span></span>
                                      </a>
                                    </div>
                                  </div>
                                  <div class="status col-mod-2">
                                    <span v-if="mydata.schedule[0].feedback.length != 0" @click="openFeedBack1(mydata.schedule[0].feedback[0].schedule_id)">
                                      <a style="color:#5bad2b; font-size: 18px; font-weight:bold;">{{ 'SIT ' + mydata.schedule[0].feedback[0].sit_score }}</a>
                                    </span>
                                    <span v-else-if="mydata.schedule.length > 1 && mydata.schedule[1].feedback.length != 0" @click="openFeedBack1(mydata.schedule[1].feedback[0].schedule_id)">
                                      <a style="color:#5bad2b; font-size: 18px; font-weight:bold;">{{ 'SIT ' + mydata.schedule[1].feedback[0].sit_score }}</a>
                                    </span>
                                    <span v-else @click="openFeedBack(mydata.id)">
                                      <a style="color:#5bad2b; font-size: 18px; font-weight:bold;">{{ 'SIT ' + mydata.sit_score }}</a>
                                    </span><br>
                                    <!-- <span @click="openFeedBack1(mydata.sch_feedback)">
                                      <a style="color:#5bad2b; font-size: 18px; font-weight:bold;">{{ 'SIT ' + mydata.sch_sit}}</a>
                                    </span><br> -->
                                    <div>
                                      <a data-toggle="modal" data-target="#viewHistoryModel"  style="color:grey; font-size: 12px; font-weight:bold;" @click="viewHistory(mydata.id)"><i class="fa fa-tags" aria-hidden="true"></i> View History </a>
                                    </div>
                                  </div>
                                  <div class="availability1 col-mod-3">
                                    <div v-if="mydata.schedule[0].status=='Selected'">
                                      <span style="margin-top:30px">
                                        <!-- <span class="direct-chat-timestamp" style="color:green;cursor:pointer;">
                                          Selected
                                        </span>&nbsp; -->
                                        <span class="direct-chat-timestamp" style="color:red;cursor:pointer;" @click="selectModal(mydata.schedule[0].id, 'rejected')">
                                            <button :disabled="postData.expired" class="btn btn-sm btn-danger"> <i class="fa fa-times" aria-hidden="true"></i> Reject</button>
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div class="box-body" v-if="this.$route.params.post_type === 'id'">
                            <ul style="list-style:none" class="profileClass">
                              <div v-if="candidateListing.length == 0 && candidateListingTemp.length == 0" class="text-muted tc" style="margin-top: 20%;">No data found</div>
                              <span v-if="status_type=='candidate' && score == '' && (status == 'New' || status == '') && fromdate == '' && todate == ''" >
                                <li v-for="(mydata, indexx) in candidateListingTemp" :key="indexx">
                                  <br>
                                  <div class="postArea2 col-mod-12" :class="{ 'warningBorder': (mydata.email === '' || mydata.email === null || mydata.email === undefined ), 'dangerBorder': (mydata.mobile === '' || mydata.mobile === null || mydata.mobile === undefined ) }">
                                    <div class="candidateArea col-mod-7" style="text-align:start">
                                      <div class="Orgimage1">
                                        <a :href="mydata.url">
                                          <img
                                            class="resume"
                                            src="../assets/img/resume2.png"
                                            alt
                                          />
                                        </a>
                                      </div>
                                      <div class="abc" >
                                        <a class="candidateDetails overflow" @click="editCandidateFn(mydata)">
                                          <span :title="mydata.first_name + ' ' + mydata.last_name" class="canName" >{{mydata.first_name}}</span>
                                          <br />
                                          <span><span style="font-size: 12px; font-weight:bold; color: grey;">Phone : </span ><span style="font-size: 12px; font-weight:bold; color: black;" :title="mydata.mobile">{{mydata.mobile}}</span></span>
                                          <br />
                                          <span><span style="font-size: 12px; font-weight:bold; color: grey;">Email : </span><span style="font-size: 12px; font-weight:bold; color: black;" :title="mydata.email">{{mydata.email}}</span></span>
                                        </a>
                                      </div>
                                    </div>
                                    <div class="status col-mod-2">
                                      <span>
                                        <a style="color:black; font-size: 14px; font-weight:bold;">{{ 'New' }}</a>
                                      </span>
                                    </div>
                                    <div v-if="mydata.email != null" class="availability1 col-mod-3">

                                    </div>
                                  </div>
                                </li>
                              </span>
                              <li v-for="(mydata, indexx) in candidateListing" :key="indexx">
                                <div class="postArea2 col-mod-12" :class="{ 'warningBorder': (mydata.email === '' || mydata.email === null || mydata.email === undefined ), 'dangerBorder': (mydata.mobile === '' || mydata.mobile === null || mydata.mobile === undefined ) }">
                                  <div class="candidateArea col-mod-7" style="text-align:start">
                                    <div class="Orgimage1" v-if="mydata.resume.length > 0">
                                      <a :href="mydata.resume[0].url">
                                        <img
                                          class="resume"
                                          src="../assets/img/resume2.png"
                                          alt
                                        />
                                      </a>
                                    </div>
                                    <div class="Orgimage1" v-else>
                                      <a>
                                        <img
                                          class="resume"
                                          src="../assets/img/resume2.png"
                                          alt
                                        />
                                      </a>
                                    </div>
                                    <div class="abc" >
                                      <a class="candidateDetails overflow" @click="editCandidateFn(mydata)">
                                        <span :title="mydata.first_name + ' ' + mydata.last_name" class="canName" >{{mydata.first_name}}</span>
                                        <br />
                                        <span>
                                          <span style="font-size: 12px; font-weight:bold; color: grey;">Phone : </span >
                                          <span v-if="mydata.mobile_country_code != '1'" style="font-size: 12px; font-weight:bold; color: black;">{{mydata.mobile_country_code != null && mydata.mobile_country_code != '' ? '+' + mydata.mobile_country_code : '' }} {{mydata.mobile}}</span>
                                          <span v-if="mydata.mobile_country_code == '1'" style="font-size: 12px; font-weight:bold; color: black;">{{mydata.mobile_country_code != null && mydata.mobile_country_code != '' ? '+' + mydata.mobile_country_code : '' }} {{'(' +mydata.mobile.substring(0,3) + ')' + mydata.mobile.substring(3,6) + '-' + mydata.mobile.substring(6,10)}}</span>
                                          <!-- <span v-if="mydata.mobile == null || mydata.mobile == ''" style="font-size: 12px; font-weight:bold; color: black;">{{ '' }}</span> -->
                                        </span>
                                        <br />
                                        <span><span style="font-size: 12px; font-weight:bold; color: grey;">Email : </span><span style="font-size: 12px; font-weight:bold; color: black;" :title="mydata.email">{{mydata.email}}</span></span>
                                      </a>
                                    </div>
                                  </div>
                                  <div class="status col-mod-2">
                                    <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'New' && mydata.schedule[0].sub_status == 'Schedule Initiated'">
                                      <a style="color:black; font-size: 14px; font-weight:bold;">{{ 'New' }}</a>
                                    </span>
                                    <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Schedule Initiated'" data-toggle="modal" data-target="#showInterviewersListModal" @click="showPanels(mydata.schedule[0].id)">
                                      <a style="color:orange; font-size: 14px; font-weight:bold;">{{ 'Schedule Request Pending' }}</a>
                                    </span>
                                    <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Accepted'" data-toggle="modal" data-target="#showInterviewersListModal" @click="showPanels(mydata.schedule[0].id)">
                                      <a style="color:orange; font-size: 14px; font-weight:bold;">{{ 'Schedule Request Pending' }}</a>
                                    </span>
                                    <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Reschedule Initiated'" data-toggle="modal" data-target="#showInterviewersListModal" @click="showPanels(mydata.schedule[0].id)">
                                      <a style="color:orange; font-size: 14px; font-weight:bold;">{{ 'Schedule Request Pending' }}</a>
                                    </span>
                                    <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Reschedule Initiated' && mydata.schedule[0].sub_status == 'Reschedule Initiated'" data-toggle="modal" data-target="#showInterviewersListModal" @click="showPanels(mydata.schedule[0].id)">
                                      <a style="color:orange; font-size: 14px; font-weight:bold;">{{ 'Re-Schedule Request Pending' }}</a>
                                    </span>
                                    <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Reschedule Initiated' && mydata.schedule[0].sub_status == 'Schedule Initiated'" data-toggle="modal" data-target="#showInterviewersListModal" @click="showPanels(mydata.schedule[0].id)">
                                      <a style="color:orange; font-size: 14px; font-weight:bold;">{{ 'Schedule Request Pending' }}</a>
                                    </span>
                                    <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule ReInitiated' && mydata.schedule[0].sub_status == 'Schedule Initiated'" data-toggle="modal" data-target="#showInterviewersListModal" @click="showPanels(mydata.schedule[0].id)">
                                      <a style="color:red; font-size: 14px; font-weight:bold;">{{ 'Declined' }}</a>
                                    </span>
                                    <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule ReInitiated' && mydata.schedule[0].sub_status == 'Accepted'" data-toggle="modal" data-target="#showInterviewersListModal" @click="showPanels(mydata.schedule[0].id)">
                                      <a style="color:red; font-size: 14px; font-weight:bold;">{{ 'Declined' }}</a>
                                    </span>
                                    <span v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule ReInitiated' && mydata.schedule[0].sub_status == 'Reschedule Initiated'" data-toggle="modal" data-target="#showInterviewersListModal" @click="showPanels(mydata.schedule[0].id)">
                                      <a style="color:red; font-size: 14px; font-weight:bold;">{{ 'Declined' }}</a>
                                    </span>
                                    <span @click="showShedule1(mydata)"  v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Scheduled'">
                                      <a style="color:blue; font-size: 14px; font-weight:bold;">Scheduled</a>
                                    </span>
                                    <span @click="showShedule1(mydata)"  v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Rescheduled' && mydata.schedule[0].sub_status != 'Schedule Initiated'">
                                      <a style="color:blue; font-size: 14px; font-weight:bold;">Rescheduled</a>
                                    </span>
                                    <span @click="showShedule1(mydata)"  v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Rescheduled' && mydata.schedule[0].sub_status == 'Schedule Initiated'">
                                      <a style="color:blue; font-size: 14px; font-weight:bold;">Scheduled</a>
                                    </span>
                                    <span v-if="mydata.schedule[0].status=='Completed' && mydata.schedule[0].feedback_status=='pending'" @click="showResult1(mydata)">
                                      <div><span style="color:#5bad2b; font-size: 14px; font-weight:bold;">Completed</span></div>
                                      <a style="color:red; font-size: 13px; font-weight:bold;">Feedback Pending</a>
                                    </span>
                                    <span v-if="mydata.schedule[0].status=='Completed' && mydata.schedule[0].feedback_status=='Completed' && mydata.schedule[0].feedback.length != 0" @click="showResult1(mydata)">
                                      <span v-if="mydata.schedule[0].feedback[0].interview_status =='Completed'">
                                        <a style="color:#5bad2b; font-size: 14px; font-weight:bold;">SIT {{ mydata.schedule[0].feedback[0].sit_score }}</a>
                                      </span>
                                      <span v-if="mydata.schedule[0].feedback[0].interview_status !='Completed'">
                                        <a style="color:red; font-size: 14px; font-weight:bold;">InComplete</a>
                                      </span>
                                    </span>
                                    <span v-if="mydata.schedule[0].status=='Cancelled'">
                                      <!-- <a style="color:red; font-size: 14px; font-weight:bold;">Cancelled</a> -->
                                      <a style="color:red; font-size: 14px; font-weight:bold;">Open</a>
                                    </span>
                                    <span v-if="mydata.schedule[0].status=='Selected'" @click="showResult1(mydata)">
                                      <a style="color:#5bad2b; font-size: 14px; font-weight:bold;">SIT {{ mydata.schedule[0].feedback[0].sit_score }}</a>
                                    </span>
                                    <span v-if="mydata.schedule[0].status=='Rejected'" @click="showResult1(mydata)">
                                      <a style="color:#5bad2b; font-size: 14px; font-weight:bold;">SIT {{ mydata.schedule[0].feedback[0].sit_score }}</a>
                                    </span>
                                  </div>
                                  <div v-if="mydata.email != null" class="availability1 col-mod-3">
                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'New' && mydata.schedule[0].sub_status == 'Schedule Initiated'">
                                      <a :disabled="postData.expired" style="color:#5bad2b" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata.schedule[0].id)">
                                        Set Availability
                                      </a>
                                    </div>
                                    <div v-if="(mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Schedule Initiated') ||
                                          (mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Accepted') ||
                                          (mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Reschedule Initiated') ||
                                          (mydata.schedule.length != 0 && mydata.schedule[0].status == 'Reschedule Initiated') ||
                                          (mydata.schedule.length != 0 && mydata.schedule[0].status == 'Scheduled') ||
                                          (mydata.schedule.length != 0 && mydata.schedule[0].status == 'Selected') ||
                                          (mydata.schedule.length != 0 && mydata.schedule[0].status == 'Rescheduled') ||
                                          (mydata.schedule.length != 0 && mydata.schedule[0].status=='Completed') ||
                                          (mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule ReInitiated' && mydata.schedule[0].sub_status == 'Schedule Initiated') ||
                                          (mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule ReInitiated' && mydata.schedule[0].sub_status == 'Reschedule Initiated')"
                                          class="validity">
                                        <div style="font-weight:bold">{{ getDateTz(mydata.schedule[0].utc_starttime, mydata.schedule[0].candidate_tz)}}</div>
                                        <div>{{ getTimeTz(mydata.schedule[0].utc_starttime, mydata.schedule[0].candidate_tz) }} to {{ getEndTimeTz(mydata.schedule[0].utc_starttime, mydata.schedule[0].candidate_tz) }} {{getSrtTz(mydata.schedule[0].candidate_tz)}}</div>
                                      </div>

                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status=='Completed' && mydata.schedule[0].feedback_status=='Completed'" style="margin-top:5px">
                                      <span :disabled="postData.expired" class="direct-chat-timestamp" style="color:red;cursor:pointer;" @click="selectModal(mydata.schedule[0].id, 'rejected')"><i class="fa fa-times" aria-hidden="true"></i>
                                          Reject
                                      </span>&nbsp;
                                      <span :disabled="postData.expired" class="direct-chat-timestamp" style="color:green;cursor:pointer;" @click="selectModal(mydata.schedule[0].id, 'selected')">
                                        <i class="fa fa-check" aria-hidden="true"></i> Select
                                      </span>&nbsp;
                                    </div>
                                    <div :disabled="postData.expired" v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Scheduled'" class="d-flex flex-row">
                                      <a :disabled="postData.expired" style="color:red; font-size: 12px; font-weight:bold;" @click="showReason1(mydata.schedule[0].id)"><i class="fa fa-times" aria-hidden="true"></i> Cancel</a>&nbsp;&nbsp;
                                      <a :disabled="postData.expired" style="color:blue" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata.schedule[0].id, 'reschedule', mydata.schedule[0].utc_starttime)">
                                        Re-Schedule
                                      </a>
                                      <button style="color:blue" class="btn connectbtn btn-sm" :disabled="checkingdate(mydata.schedule[0].utc_starttime, mydata.schedule[0].utc_starttime) == 'no'"  @click="connect(mydata.schedule[0].meeting_id,mydata.schedule[0].id,mydata.schedule[0].user_id, mydata.schedule[0])">
                                        Connect
                                      </button>
                                    </div>
                                    <div :disabled="postData.expired" v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Rescheduled' && mydata.schedule[0].sub_status != 'Schedule Initiated'" class="d-flex flex-row">
                                      <a :disabled="postData.expired" style="color:red; font-size: 12px; font-weight:bold;" @click="showReason1(mydata.schedule[0].id)"><i class="fa fa-times" aria-hidden="true"></i> Cancel</a>&nbsp;&nbsp;
                                      <button style="color:blue" class="btn connectbtn btn-sm" :disabled="checkingdate(mydata.schedule[0].utc_starttime, mydata.schedule[0].utc_starttime) == 'no'"  @click="connect(mydata.schedule[0].meeting_id,mydata.schedule[0].id,mydata.schedule[0].user_id, mydata.schedule[0])">
                                        Connect
                                      </button>
                                    </div>
                                    <div :disabled="postData.expired" v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Rescheduled' && mydata.schedule[0].sub_status == 'Schedule Initiated'" class="d-flex flex-row">
                                      <a :disabled="postData.expired" style="color:red; font-size: 12px; font-weight:bold;" @click="showReason1(mydata.schedule[0].id)"><i class="fa fa-times" aria-hidden="true"></i> Cancel</a>&nbsp;&nbsp;
                                      <a :disabled="postData.expired" style="color:blue" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata.schedule[0].id, 'reschedule', mydata.schedule[0].utc_starttime)">
                                        Re-Schedule
                                      </a>
                                      <button style="color:blue" class="btn connectbtn btn-sm" :disabled="checkingdate(mydata.schedule[0].utc_starttime, mydata.schedule[0].utc_starttime) == 'no'"  @click="connect(mydata.schedule[0].meeting_id,mydata.schedule[0].id,mydata.schedule[0].user_id, mydata.schedule[0])">
                                        Connect
                                      </button>
                                    </div>
                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Schedule Initiated'">
                                      <a :disabled="postData.expired" style="color:blue" class="pull-right" @click="scheduleAvailability(mydata.schedule[0].id)">
                                        Schedule
                                      </a>
                                    </div>
                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Accepted'">
                                      <a :disabled="postData.expired" style="color:blue" class="pull-right" @click="scheduleAvailability(mydata.schedule[0].id)">
                                        Schedule
                                      </a>
                                    </div>
                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule Initiated' && mydata.schedule[0].sub_status == 'Reschedule Initiated'">
                                      <a :disabled="postData.expired" style="color:blue" class="pull-right" @click="scheduleAvailability(mydata.schedule[0].id)">
                                        Schedule
                                      </a>
                                    </div>
                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Reschedule Initiated'  && mydata.schedule[0].sub_status == 'Reschedule Initiated'">
                                      <a :disabled="postData.expired" style="color:red; font-size: 12px; font-weight:bold;" @click="showReason1(mydata.schedule[0].id)"><i class="fa fa-times" aria-hidden="true"></i> Cancel</a>&nbsp;&nbsp;
                                      <a :disabled="postData.expired" style="color:blue" class="pull-right" @click="scheduleAvailability(mydata.schedule[0].id)">
                                        Schedule
                                      </a>
                                    </div>
                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Reschedule Initiated' && mydata.schedule[0].sub_status == 'Schedule Initiated'">
                                      <a :disabled="postData.expired" style="color:blue" class="pull-right" @click="scheduleAvailability(mydata.schedule[0].id)">
                                        Schedule
                                      </a>
                                    </div>
                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Schedule ReInitiated' && (mydata.schedule[0].sub_status == 'Schedule Initiated' || mydata.schedule[0].sub_status == 'Reschedule Initiated' )">
                                      <a :disabled="postData.expired" style="color:#5bad2b" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata.schedule[0].id)">
                                        Set Availability &nbsp;
                                      </a>
                                      <a :disabled="postData.expired" style="color:blue" class="pull-right" @click="scheduleAvailability(mydata.schedule[0].id)">
                                        Schedule
                                      </a>
                                    </div>
                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Cancelled'">
                                      <!-- <button class="btn btn-sm btn btn-primary pull-right" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata.schedule[0].id, 'resch')">
                                        Re-Schedule
                                      </button> -->
                                      <a :disabled="postData.expired" style="color:#5bad2b" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata.schedule[0].id)">
                                        Set Availability
                                      </a>
                                    </div>
                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Selected'">
                                      <span class="direct-chat-timestamp" style="color:green;cursor:pointer;">
                                        Selected
                                      </span>
                                    </div>
                                    <div v-if="mydata.schedule.length != 0 && mydata.schedule[0].status == 'Rejected'">
                                      <span class="direct-chat-timestamp" style="color:red;cursor:pointer;">
                                        Rejected
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="tab-pane" id="timeline">
<div class="skillset">
</div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- modal for uploadResume -->
      <div
        class="modal fade"
        id="uploadResume"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="exampleModalLabel">
                Upload Candidate Resume
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <div class="custom-file-upload">
                  <div v-if="resumefiles.length < 1" class="show-doc-empty">
                    Select the File
                  </div>
                  <div class="show-doc" v-if="resumefiles.length > 0">
                    <span
                      class="doc-file pull-left"
                      v-for="(x, index) in resumefiles.slice(0, 2)"
                      :key="index"
                    >
                      <span class="doc-name">{{ x.name }}</span>
                      <i
                        @click="removeUploading(index)"
                        class="fa fa-times"
                        style="color: #ccc;"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>
                  <label for="file1">
                    <i class="uil uil-upload" aria-hidden="true"></i> Upload
                  </label>
                  <input
                    @change="fileUpload1($event)"
                    style="visibility: hidden;"
                    type="file"
                    id="file1"
                    name="myfiles[]"
                    multiple
                  />
                </div>
                <p style="color: red;margin: 3px 0 10px; font-size: 12px;">{{errormsg}}</p>
                <p style="color: #aeaaaa;margin: 3px 0 10px;">
                  Supported format (.pdf, .docx), Size (Max 3MB)
                </p>
              </div>
              <div v-if="resumefiles.length > 0">
                <div v-for="(y, ind) in resumefiles" :key="ind">
                  <div class="row">
                    <div>
                      <span class="doc-name col-md-5 p-1">{{ y.name }}</span>
                      <i
                        @click="removeUploading(ind)"
                        class="fa fa-times"
                        style="color: #ccc;"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Save changes</button>-->
              <button
                :disabled="resumefiles.length < 1 || resumeBtnDisabled"
                type="button"
                @click="UploadCandidateResume()"
                style="margin-right: 10px;"
                class="btn btn-success"
              >
                Submit
              </button>
              <button
                data-dismiss="modal"
                type="button"
                class="btn btn-default"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal for Set Availability---->
      <div
        class="modal fade"
        id="setAvailability"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content AvailabilityPopup">
            <div class="modal-header">
              <h4 class="modal-title" id="exampleModalLabel">
                <span v-if="setAvailabilityType=='resch'">Reschedule</span>
                <span v-if="setAvailabilityType=='reschedule'">Reschedule</span>
                <span v-else>Set Availability</span>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" class="modalClose">&times;</span>
                </button>
              </h4>
            </div>
            <div class="modal-body">
              <div class="setavailability">
                <div class="form-group" v-if="setAvailabilityType=='reschedule'">
                  <div class="form-select">
                    <select id="reason" v-model="reScheduleReason" class="form-control is-valid">
                      <option value=''>Select the Reason *</option>
                      <option v-for="x in reasonList" v-bind:value="x" :key="x.id">{{x.name}}</option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                  </div><br>
                </div>
                <div v-if="setAvailabilityType=='reschedule'">
                  <b-form-textarea v-model="reScheduleComments" class="textarea" rows="5" placeholder="Enter Comments*"></b-form-textarea><br>
                </div>
                <datetime
                  v-model="availability"
                  format="dd-MMM-yyyy hh:mm a"
                  :min-datetime="minDatetime1"
                  :minute-step="30"
                  type="datetime"
                  :value-zone="timezone"
                  :zone="timezone"
                  use12-hour
                  placeholder="Select Date *"
                >
                </datetime>
                <br>
                <div class="form-select" style="height:41px; margin-top:5px">
                  <select
                    class="form-control"
                    placeholder="Select Type"
                    style="height:41px;min-width:150px; border: 1px solid lightgrey !important;"
                    v-model="candidateTimezone"
                  >
                    <option disabled selected
                      >Select Candidate Timezone</option
                    >
                    <option value="Asia/Calcutta">IST</option>
                    <option value="America/New_York">EST</option>
                    <option value="Europe/London">GMT</option>
                    <option value="America/Chicago">CST</option>
                    <option value="America/Los_Angeles">PST</option>
                    <option value="Pacific/Honolulu">HST</option>
                    <option value="America/Anchorage">AHST</option>
                  </select>
                  <span class="select-icon"
                    ><i class="fa fa-chevron-down"></i
                  ></span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button :disabled="disableSetAvailabilityButton" type="button" @click="setAvailability()" class="btn btn-success">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal overlay fade in" id="myModal1">
      <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
        <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
          <div class="modal-body" style="padding:0px">
            <div class="row" >
              <div class="col-md-12 " style="padding:17px">
                <div class="col-md-12" style="text-align: center;">
                  <p style="font-size: 20px;font-weight: 400;">{{infoName}}</p><br>
                  <button class="btn btn-success" @click="closeViolated()">Ok</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <div class="modal overlay fade in" id="selectModalShow">
      <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
        <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
          <div class="modal-body" style="padding:0px">
            <div class="row" >
              <div class="col-md-12 " style="padding:17px">
                <div class="col-md-12" style="text-align: center;">
                  <p style="font-size: 20px;font-weight: 400;" v-if="selected=='selected'">Are you sure want to select this candidate?</p>
                  <p style="font-size: 20px;font-weight: 400;" v-if="selected=='rejected'">Are you sure want to reject this candidate?</p><br>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="selectCandidate()">Yes</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <div class="modal overlay fade in" id="showInterviewersListModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content AvailabilityPopup">
          <div class="modal-header">
            <h3 class="modal-title">
              <span>Invited Interviewers</span>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
              >
                <span aria-hidden="true" class="modalClose">&times;</span>
              </button>
            </h3>
          </div>
          <div class="modal-body" style="padding:0px">
            <div class="row" >
              <div class="col-md-12 " style="padding:17px">
                <div class="col-md-12">
                  <p style="font-size: 18px;font-weight: 400; text-align: start;" v-if="interviewersListErrorMsg!=''">{{interviewersListErrorMsg}}</p>
                  <div class="col-sm-12" v-else>
                    <div class="table-responsive text-nowrap">
                      <table id="example1" class="table table-striped" role="grid" aria-describedby="example1_info" style="font-size: 12px;">
                        <thead>
                          <tr role="row" style="text-align: center">
                            <th rowspan="1" colspan="1">Interviewer Name</th>
                            <!-- <th rowspan="1" colspan="1">Phone</th> -->
                            <th rowspan="1" colspan="1">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr role="row" class="odd" v-for="(x, ind) in interviewersList" :key="ind">
                            <td>{{x.interviewer.candidate.first_name}} {{x.interviewer.candidate.last_name}}</td>
                            <!-- <td>{{x.interviewer.candidate.mobile}}</td> -->
                            <td>
                              <span v-if="x.select_tag == null || x.select_tag == 'pending'">Pending</span>
                              <span v-if="x.select_tag == 'true'">Accepted</span>
                              <span v-if="x.select_tag == 'false'">Declined</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="text-align: center;">
            <button class="btn btn-success" data-dismiss="modal">Ok</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <div class="modal overlay fade in" id="viewHistoryModel">
      <div class="modal-dialog" role="document">
        <div class="modal-content AvailabilityPopup">
          <div class="modal-header">
            <h3 class="modal-title">
              <span>Interview History</span>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
              >
                <span aria-hidden="true" class="modalClose">&times;</span>
              </button>
            </h3>
          </div>
          <div class="modal-body" style="padding:0px">
            <div class="row" >
              <div class="col-md-12 " style="padding:17px">
                <div class="col-md-12">
                  <p style="font-size: 18px;font-weight: 400; text-align: start;" v-if="historyErrorMsg!=''">{{historyErrorMsg}}</p>
                  <div class="col-sm-12" v-else>
                    <div class="table-responsive text-nowrap">
                      <table id="example1" class="table table-striped" role="grid" aria-describedby="example1_info" style="font-size: 12px;">
                        <thead>
                          <tr role="row" style="text-align: center">
                            <th rowspan="1" colspan="1">Level</th>
                            <th rowspan="1" colspan="1">Type</th>
                            <th rowspan="1" colspan="1">Score</th>
                            <th rowspan="1" colspan="1"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr role="row" class="odd" v-for="(x, ind) in historyList" :key="ind">
                            <td>{{x.level}}</td>
                            <td>{{ x.interviewer.type }}</td>
                            <td><a style="color:#5bad2b; font-size: 12px; font-weight:bold;">{{ 'SIT '+ x.feedback[0].sit_score}}</a></td>
                            <td><a style="font-size: 12px; font-weight:bold; color:green;" @click="showResult(x)">View Feedback</a></td>
                          </tr>
                          <tr role="row" class="odd" v-if="historyList1 != null">
                            <td>{{historyList1.level}}</td>
                            <td>{{ "ScreenIT" }}</td>
                            <td>
                              <a v-if="historyList1.feedback.length != 0" style="color:#5bad2b; font-size: 12px; font-weight:bold;">{{ 'SIT '+ historyList1.feedback[0].sit_score}}</a>
                              <a v-if="historyList1.feedback.length == 0" style="color:#5bad2b; font-size: 12px; font-weight:bold;">-</a>
                            </td>
                            <td>
                              <a v-if="historyList1.feedback.length != 0" style="font-size: 12px; font-weight:bold; color:green;" @click="openFeedBack1(historyList1.feedback[0].schedule_id)">View Feedback</a>
                              <a v-if="historyList1.feedback.length == 0" style="font-size: 12px; font-weight:bold; color:green;">-</a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="text-align: center;">
            <button class="btn btn-success" data-dismiss="modal">Ok</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <EditCandidate v-if="editCandidate" @editCandidate_emit="oncloseEditCandidate" :data="canData" :postID="this.$route.params.post_id" :shwovalueEditCandidate="editCandidate"></EditCandidate>
    <reason-popup v-model="reasonOpen" :shwovalueReason="reasonOpen" v-if="reasonOpen"></reason-popup>
    <ResultShow v-model="resultOpen" :shwovalueResultResult="resultOpen" v-if="resultOpen"></ResultShow>
    <ResultShow1 v-model="resultOpen1" :shwovalueResultResult="resultOpen1" v-if="resultOpen1"></ResultShow1>
    <ScheduleDetails v-model="sheduleOpen" :shwovalueScheduleDetails="sheduleOpen" v-if="sheduleOpen"></ScheduleDetails>
  </div>
</template>
<script>
// import { CContainer } from '@coreui/vue'
import router from '../router/index'
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
// import moment from 'moment'
import Vue from 'vue'
import ScheduleDetails from './scheduledetail_v3'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
// import * as Cookies from 'js-cookie'
import $ from 'jquery'
import EditCandidate from './EditCandidate_v3.vue'
import ReasonPopup from './reasonpopup_v3'
import JwPagination from 'jw-vue-pagination'
import momentsone from 'moment-timezone'
import moment from 'moment'
import ResultShow from './result_popup_v3'
import ResultShow1 from './result_popup1_v3'

Vue.component('jw-pagination', JwPagination)
const timezoneList = [
  { id: 0, name: 'IST', fullName: 'Asia/Kolkata' },
  { id: 1, name: 'IST', fullName: 'Asia/Calcutta' },
  { id: 2, name: 'EST', fullName: 'America/New_York' },
  { id: 3, name: 'GMT', fullName: 'Europe/London' },
  { id: 4, name: 'CST', fullName: 'America/Chicago' },
  { id: 5, name: 'PST', fullName: 'America/Los_Angeles' },
  { id: 6, name: 'HST', fullName: 'Pacific/Honolulu' },
  { id: 7, name: 'AHST', fullName: 'America/Anchorage' }
]
const optionsOverrides1 = {
  durations: {
    global: 3000
  },
  icons: {
    enabled: false
  },
  labels: {
    success: '',
    warning: '',
    alert: ''
  },
  position: 'bottom-right'
}
export default {
  data () {
    return {
      fullPage: true,
      isLoading: false,
      postId: '',
      postsearch: '',
      postsort: 7,
      user_id: localStorage.getItem('user_id'),
      candidateListing: [],
      myCurrentDate: '',
      myPastDate: '',
      startdate: '',
      enddate: '',
      bookmarkValue: '',
      resumefiles: [],
      uploadCandidateResume: true,
      activeFilter: '',
      status: '',
      score: '6',
      fromdate: '',
      todate: '',
      pages: [1, 2, 3, 4],
      minDatetime1: '',
      availability: '',
      id: '',
      editCandidate: false,
      canData: null,
      postData: null,
      infoName: '',
      reasonOpen: false,
      viewid: '',
      timezone: momentsone.tz.guess(),
      timezonetype: '',
      type: this.$route.params.type,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      scheduleId: '',
      setAvailabilityType: '',
      reasonList: [],
      reScheduleReason: '',
      reScheduleComments: '',
      selected: '',
      resultOpen: false,
      resultOpen1: false,
      selectedSt: '',
      sit: '',
      current_date: '',
      sheduleOpen: false,
      errormsg: '',
      interviewersList: [],
      showInterviewersListModal: false,
      interviewersListErrorMsg: '',
      exampleItems: [],
      skip: 0,
      disableSetAvailabilityButton: false,
      selectedUserList: [],
      shortListed: false,
      metrix: null,
      status_type: 'candidate',
      candidateListing_schedule: [],
      viewHistoryModel: false,
      historyErrorMsg: '',
      historyList: [],
      historyList1: null,
      sit6: '',
      candidateListingTemp: [],
      selectedAvailableTime: '',
      resumeBtnDisabled: false,
      candidateTimezone: '',
      interviewerCount: ''
    }
  },
  components: {
    EditCandidate, ReasonPopup, ResultShow, ScheduleDetails, Loading, ResultShow1
  },
  created () {
    this.candidateTimezone = this.timezone
    const currentTime = moment().tz(moment.tz.guess())
    this.timezoneApp = currentTime.format('z')
    if (this.type === '2' || this.type === 2) {
      this.typename = 'interviewer'
    } else {
      this.typename = 'candidate'
    }
    if (this.timezoneApp === 'EDT') {
      this.timezoneApp = 'EST'
    } else if (this.timezoneApp === 'PDT') {
      this.timezoneApp = 'PST'
    } else if (this.timezoneApp === 'AKDT') {
      this.timezoneApp = 'AHST'
    }
    this.getreasondata()
    if (this.$route.params.post_type === 'id') {
      if (this.$route.params.selectedMetrics === '') {
        this.status_type = 'candidate'
      } else if (this.$route.params.selectedMetrics === 'Profiles') {
        this.status_type = 'candidate'
      } else if (this.$route.params.selectedMetrics === 'Scheduled') {
        this.status_type = 'scheduled'
        this.status = 'Scheduled'
      } else if (this.$route.params.selectedMetrics === 'SIT>6') {
        this.status_type = 'sit'
        this.sit6 = 'true'
      } else if (this.$route.params.selectedMetrics === 'Selected') {
        this.status_type = 'select'
        this.status = 'Selected'
      }
    } else if (this.$route.params.post_type === 'jd') {
      if (this.$route.params.selectedMetrics === '') {
        this.status_type = 'candidate'
      } else if (this.$route.params.selectedMetrics === 'Profiles') {
        this.status_type = 'candidate'
      } else if (this.$route.params.selectedMetrics === 'Shortlisted') {
        this.status_type = 'shortlist'
      } else if (this.$route.params.selectedMetrics === 'Scheduled') {
        this.status_type = 'scheduled'
      } else if (this.$route.params.selectedMetrics === 'Selected') {
        this.status_type = 'select'
      }
    }
    if (this.$route.params.post_type === 'jd') {
      this.getPostDetails()
      this.candidateList(this.status_type)
    } else {
      this.score = ''
      this.getPostDetailsId()
      // this.getPostDetails()
    }
    localStorage.getItem('user_id')
    localStorage.getItem('user__details')
  },
  mounted () {
    var d = new Date()
    var day = this.addZero(d.getDate())
    var month = this.addZero(d.getMonth() + 1)
    var year = this.addZero(d.getFullYear())
    this.minDatetime1 = year + '-' + month + '-' + day
    this.$root.$on('message_from_tobe', (arg) => {
      if (this.$route.params.post_type === 'jd') {
        this.candidateList('scheduled')
      } else {
        this.getPostDetailsId()
      }
    })
  },
  methods: {
    getDate (date) {
      return moment(date).utc().tz(this.timezone).format('DD MMM YYYY')
    },
    getTime (date) {
      return moment(date).utc().tz(this.timezone).format('hh:mm a')
    },
    getEndTime (date) {
      return moment(date).utc().tz(this.timezone).add(1, 'h').format('hh:mm a')
    },
    getDateTz (date, tz) {
      return moment(date).utc().tz(tz).format('DD MMM YYYY')
    },
    getTimeTz (date, tz) {
      return moment(date).utc().tz(tz).format('hh:mm a')
    },
    getEndTimeTz (date, tz) {
      return moment(date).utc().tz(tz).add(1, 'h').format('hh:mm a')
    },
    getSrtTz (tz) {
      var timezonetype
      for (let i = 0; i < timezoneList.length; i++) {
        if (timezoneList[i].fullName === tz) {
          timezonetype = timezoneList[i].name
        }
      }
      return timezonetype
    },
    viewHistory (candidateId) {
      axios
        .get(BaseURLV3 + '/org/' + this.$route.params.post_id + '/' + candidateId + '/schedule')
        .then(response => {
          if (response.data.success) {
            this.historyList = response.data.schedule
            this.historyList1 = response.data.screenit_schedule
            this.viewHistoryModel = true
          } else {
            this.$awn.alert(response.data.msg, optionsOverrides1)
          }
        })
    },
    async viewHistorySit (candidateId) {
      var sit
      await axios
        .get(BaseURLV3 + '/org/' + this.$route.params.post_id + '/' + candidateId + '/schedule')
        .then(response => {
          if (response.data.success) {
            if (response.data.schedule.length === 0) {
              sit = response.data.screenit_schedule.feedback[0].sit_score
            } else {
              sit = response.data.schedule[response.data.schedule.length - 1].feedback.sit_score
            }
          } else {
            this.$awn.alert(response.data.msg, optionsOverrides1)
          }
        })
      return sit
    },
    selectone (force) {
      if (force.shortlisted === 'Yes') {
        Vue.set(force, 'shortlisted', 'No')
        this.selectedUserList.forEach((value, index) => {
          if (value === force.id) {
            this.selectedUserList.splice(index, 1)
          }
        })
      } else {
        Vue.set(force, 'shortlisted', 'Yes')
        this.selectedUserList.push(force.id)
      }
    },
    addZero (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    showResult (scheduleData) {
      localStorage.setItem('scheduleData', JSON.stringify(scheduleData))
      if (scheduleData.candidate.designation === null || scheduleData.candidate.designation === '') {
        localStorage.setItem('designation', JSON.stringify(this.postData.job_title))
      } else {
        localStorage.setItem('designation', JSON.stringify(scheduleData.candidate.designation))
      }
      this.resultOpen = true
    },
    showResult1 (scheduleData) {
      localStorage.setItem('scheduleData', JSON.stringify(scheduleData))
      if (scheduleData.designation === null || scheduleData.designation === '' || scheduleData.designation === undefined) {
        localStorage.setItem('designation', JSON.stringify(this.postData.job_title))
      } else {
        localStorage.setItem('designation', JSON.stringify(scheduleData.designation))
      }

      this.resultOpen1 = true
    },
    getreasondata () {
      axios.get(BaseURLV3 + '/interviewer/cancel_reason', this.config).then(response => {
        this.reasonList = response.data.reason
      }).catch(e => {
      })
    },
    checkingdate (date, end) {
      var currentDate = new Date()
      this.current_date = moment(String(currentDate)).format('YYYYMMDDHHmm')
      var scheduledate = moment.utc(date).subtract(5, 'minutes').toDate()
      scheduledate = moment.utc(scheduledate).tz(this.timezone).format('YYYYMMDDHHmm')
      var endtime1 = moment.utc(end).add(1, 'hours').toDate()
      var endtime = moment.utc(endtime1).tz(this.timezone).format('YYYYMMDDHHmm')
      if (this.current_date >= scheduledate && this.current_date < endtime) {
        return 'yes'
      } else {
        return 'no'
      }
    },
    selectInterviewer (type) {
      // router.push({ name: 'SelectInterviewer' })
      this.$router.push('/select_interviewer_v3/' + this.$route.params.post_id + '/' + type + '/' + this.$route.params.post_type)
    },
    // setAvailability () {
    //   router.push({ name: 'SetAvailability' })
    // },
    getPostDetailsId () {
      if (this.score !== '') {
        this.sit6 = ''
      }
      var from = this.fromdate
      var to = this.fromdate
      if (this.fromdate !== '') {
        from = moment(String(this.fromdate)).utc().format('YYYY-MM-DD HH:mm')
      }
      if (this.todate) {
        to = moment(String(this.todate)).utc().add(1, 'd').format('YYYY-MM-DD HH:mm')
      }
      var data = {
        search: this.postsearch,
        status: this.status,
        sit: this.score,
        from: from,
        to: to,
        greater: this.sit6
      }
      axios
        .post(BaseURLV3 + '/org/' + this.$route.params.post_id + '/id_profile', data)
        .then(response => {
          if (response.data.success) {
            this.postData = response.data.post
            this.postData.expired = false // this.datas.post_validity
            var currentDate = new Date()
            var validity = moment
              .utc(this.postData.post_validity)
              .format('YYYYMMDDHHmm')
            var currentdate = moment(String(currentDate)).format(
              'YYYYMMDDHHmm'
            )
            if (currentdate > validity) {
              this.postData.expired = true
            }
            this.postData.primarySkillName = ''
            for (var j = 0; j < this.postData.p_p_skill.length; j++) {
              if (this.postData.primarySkillName === '') {
                this.postData.primarySkillName = this.postData.p_p_skill[j].skill.name
              } else {
                this.postData.primarySkillName = this.postData.primarySkillName + ', ' + this.postData.p_p_skill[j].skill.name
              }
            }
            // this.postData.job_title = 'aa'
            // this.postData.unique_id = 'id'
            // this.postData.primarySkillName = 'skill'
            // this.postData.post_type = 'id'
            this.postDataID = response.data
            this.candidateListing = this.postDataID.candidate
            this.candidateListingTemp = this.postDataID.temp_candidate
          } else {

          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPostDetails () {
      axios
        .get(BaseURLV3 + '/org/post/' + this.$route.params.post_id)
        .then(response => {
          if (response.data.success) {
            this.interviewerCount = response.data.interviewer_count
            this.postData = response.data.post
            this.postData.expired = false // this.datas.post_validity
            var currentDate = new Date()
            var validity = moment
              .utc(this.postData.post_validity)
              .format('YYYYMMDDHHmm')
            var currentdate = moment(String(currentDate)).format(
              'YYYYMMDDHHmm'
            )
            if (currentdate > validity) {
              this.postData.expired = true
            }
            this.metrix = response.data
            this.postData.primarySkillName = ''
            for (var j = 0; j < this.postData.p_p_skill.length; j++) {
              if (this.postData.primarySkillName === '') {
                this.postData.primarySkillName = this.postData.p_p_skill[j].skill.name
              } else {
                this.postData.primarySkillName = this.postData.primarySkillName + ', ' + this.postData.p_p_skill[j].skill.name
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    shortlistCandidate (candidateId) {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      // var str = this.selectedUserList.join(',')
      var data = {
        candidate: candidateId
      }
      axios
        .post(BaseURLV3 + '/org/' + this.$route.params.post_id + '/post/req_shortlist', data, config)
        .then(response => {
          if (response.data.success) {
            this.getPostDetails()
            this.candidateList(this.status_type)
            this.$awn.success(response.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    removeShortList (id) {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      axios
        .delete(BaseURLV3 + '/org/' + this.$route.params.post_id + '/' + id + '/shortlist', config)
        .then(response => {
          if (response.data.success) {
            this.getPostDetails()
            this.shortListed = true
            this.candidateList('shortlist')
            this.$awn.success(response.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    connect (id, sid, x) {
      localStorage.setItem('organization', this.userInfo.org_name)
      localStorage.setItem('job_title', this.postData.job_title)
      localStorage.setItem('channel', id)
      localStorage.setItem('type', '1')
      localStorage.setItem('sid', sid)
      localStorage.setItem('name', this.userInfo.first_name + ' ' + this.userInfo.last_name)
      localStorage.setItem('stType', '1')
      var str = BaseURLV3.substr(BaseURLV3.lastIndexOf('/') + 1)
      var url = BaseURLV3.replace(new RegExp(str), '')
      window.open(url + 'screenitMeeting/#/meeting')
    },
    async candidateList (type = 'candidate') {
      this.status_type = type
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      if (type === 'candidate') {
        var data = {
          search: this.postsearch,
          sit: this.score === '' ? '6' : this.score
        }
        axios
          .post(BaseURLV3 + '/org/' + this.$route.params.post_id + '/relevant_candidate', data, config)
          .then(response => {
            this.candidateListing = []
            if (response.data.success) {
              if (type === 'candidate') {
                this.candidateListing = response.data.relevant_candidate
              } else if (type === 'shortlist') {
                this.candidateListing = response.data.shortlisted_candidate
              }
            } else {

            }
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        var apit = 'relevant_shortlist'
        if (type === 'shortlist') {
          apit = 'relevant_shortlist'
        } else if (type === 'scheduled') {
          apit = 'relevant_schedule'
        } else if (type === 'select') {
          apit = 'relevant_select'
        }
        var data1 = {
          search: this.postsearch,
          sit: this.score === '' ? '6' : this.score
        }
        axios
          .post(BaseURLV3 + '/org/' + this.$route.params.post_id + '/' + apit, data1, config)
          .then(async response => {
            this.candidateListing = []
            this.candidateListing_schedule = []
            if (response.data.success) {
              if (type === 'candidate') {
                this.candidateListing = response.data.relevant_candidate
              } else if (type === 'shortlist') {
                this.candidateListing = response.data.shortlisted_candidate
              } else if (type === 'scheduled') {
                this.candidateListing = response.data.candidate
              } else if (type === 'select') {
                this.candidateListing = response.data.candidate
              }
            } else {

            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getDatas () {
      // var status1
      // if (this.status === 'Selected') {
      //   this.selectedSt = 'Yes'
      //   status1 = ''
      // } else if (this.status === 'Rejected') {
      //   this.selectedSt = 'No'
      //   status1 = ''
      // } else {
      //   status1 = this.status
      // }
      // const data = {
      //   skip: this.skip,
      //   post_id: this.$route.params.id,
      //   search: this.postsearch,
      //   status: status1,
      //   score: this.score,
      //   fromdate: this.fromdate,
      //   todate: this.todate,
      //   sit: this.sit,
      //   selected: this.selectedSt
      // }
      // axios
      //   .post(BaseURLV3 + '/dashboard/get_upload_candidate', { formData: data })
      //   .then(response => {
      //     this.candidateListing = response.data.candidate_list
      //   })
      //   .catch(error => {
      //     console.log(error)
      //   })
    },
    onChangePage (pageOfItems) {
      this.skip = pageOfItems[0]
      this.getDatas()
    },
    fileUpload1 (e) {
      this.resumefiles = []
      this.errormsg = ''
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (
          e.target.files[k].type ===
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          e.target.files[k].type === 'application/pdf'
        ) {
          if (e.target.files[k].size < '3000001') {
            this.resumefiles.push(e.target.files[k])
          } else {
            this.errormsg = 'Please upload the file with size <3 MB'
          }
        } else {
          this.errormsg = 'Please upload only pdf or doc format'
        }
      }
      $('#file1').val('')
    },
    removeUploading (index) {
      this.resumefiles.splice(index, 1)
    },
    cancelUploading () {
      this.resumefiles = []
      this.uploadCandidateResume = false
    },
    clearFilter () {
      this.status = ''
      this.score = ''
      this.fromdate = ''
      this.todate = ''
      this.sit = ''
      this.sit6 = ''
      this.selectedSt = ''
      if (this.$route.params.post_type === 'jd') {
        this.candidateList(this.status_type)
      } else {
        this.status_type = 'candidate'
        this.getPostDetailsId()
      }
    },
    viewFeedback (id) {
      // router.push({ name: 'newFeedback' })
      var routerPage = router.resolve('/viewfeedback_org/' + id)
      window.open(routerPage.href, '_blank')
    },
    editCandidateFn (data) {
      this.canData = data
      this.editCandidate = true
    },
    oncloseEditCandidate (val) {
      this.editCandidate = val.close
      if (val.reload === true) {
        // this.skip = 0
        // this.candidateList()
        this.getPostDetailsId()
      }
    },
    openInfo (x) {
      if (x.interviewer_accept === 'yes' && x.status === 'Accepted') {
        this.infoName = x.user_first_name + ' ' + x.user_last_name
        this.infoName = this.infoName + ' has accepted the schedule'
      } else if (x.interviewer_cancel === 'yes' && x.status === 'Declined') {
        this.infoName = x.user_first_name + ' ' + x.user_last_name
        this.infoName = this.infoName + ' has declined the schedule'
      } else if (x.candidate_accept === 'yes' && x.status === 'Accepted') {
        this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = this.infoName + ' has accepted the schedule'
      } else if (x.candidate_cancel === 'yes' && x.status === 'Declined') {
        this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = this.infoName + ' has declined the schedule'
      } else if (x.status === 'Auto-Declined') {
        // this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = 'Schedule has been auto declined since the interviewer’s calendar has been blocked for another interview.'
      }
      $('#myModal1').modal('show')
    },
    closeViolated () {
      $('#myModal1').modal('hide')
    },
    selectModal (_id, select) {
      this.scheduleId = _id
      this.selected = select
      $('#selectModalShow').modal('show')
    },
    selectCandidate () {
      this.mainurl = '/org/' + this.scheduleId + '/select'
      var formData = {
        action: this.selected
      }
      axios.post(BaseURLV3 + this.mainurl, formData, this.config).then(response => {
        if (response.data.success) {
          $('#selectModalShow').modal('hide')
          this.$awn.success(response.data.msg)
          if (this.$route.params.post_type === 'jd') {
            this.candidateList(this.status_type)
            this.getPostDetails()
          } else {
            this.getPostDetailsId()
          }
        } else {
          this.$awn.success(response.data.msg, optionsOverrides1)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    setAvailabilityDataSet (sid, type = 'schedule', avTime = '') {
      this.reScheduleReason = ''
      this.reScheduleComments = ''
      this.scheduleId = sid
      this.selectedAvailableTime = ''
      if (avTime !== '') {
        this.selectedAvailableTime = avTime
      }
      this.availability = ''
      this.setAvailabilityType = type
    },
    setAvailabilityDataSets (data, type = 'schedule') {
      this.scheduleId = data.candidate.id
      this.postId = this.$route.params.post_id
      this.setAvailabilityType = type
    },
    scheduleAvailability (sid) {
      axios.get(BaseURLV3 + '/org/' + sid + '/add_interviewer_schedule', this.config).then(response => {
        if (response.data.success) {
          this.$awn.success(response.data.msg)
          this.getPostDetailsId()
        } else {
          this.$awn.alert(response.data.msg, optionsOverrides1)
          this.getPostDetailsId()
        }
      }).catch(e => {
        this.disableSetAvailabilityButton = false
        console.log(e)
      })
    },
    scheduleAvailabilityJD (sid) {
      axios.get(BaseURLV3 + '/org/' + sid + '/add_interviewer_schedule', this.config).then(response => {
        if (response.data.success) {
          this.$awn.success(response.data.msg)
          this.candidateList(this.status_type)
          this.getPostDetails()
        } else {
          this.$awn.alert(response.data.msg, optionsOverrides1)
          this.candidateList(this.status_type)
          this.getPostDetails()
        }
      }).catch(e => {
        this.disableSetAvailabilityButton = false
        console.log(e)
      })
    },
    setAvailabilityRequestResch (sid, type) {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      var data = {
        interview_type: type,
        tz: this.timezone
      }
      axios
        .post(BaseURLV3 + '/org/' + sid + '/reschedule', data, config)
        .then(response => {
          if (response.data.success) {
            this.$awn.success(response.data.msg)
            if (this.$route.params.post_type === 'jd') {
              this.candidateList(this.status_type)
              this.getPostDetails()
            } else {
              this.getPostDetailsId()
            }
          } else {
            this.$awn.alert(response.data.msg, optionsOverrides1)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    setAvailabilityRequest (sid, type) {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      var data = {
        interview_type: type,
        tz: this.timezone
      }
      axios
        .post(BaseURLV3 + '/org/' + sid + '/post/req_schedule', data, config)
        .then(response => {
          if (response.data.success) {
            this.$awn.success(response.data.msg)
            if (this.$route.params.post_type === 'jd') {
              this.candidateList(this.status_type)
              this.getPostDetails()
            } else {
              this.getPostDetailsId()
            }
          } else {
            this.$awn.alert(response.data.msg, optionsOverrides1)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    openFeedBack1 (id) {
      if (id !== 'dummy') {
        var routeData = router.resolve({ path: '/viewfeedbackcommon_v3/' + id + '/web' })
        window.open(routeData.href, '_blank')
      } else {
        this.openFeedBackIaas(id)
      }
    },
    openFeedBackIaas (id) {
      // var routeData = router.resolve({ path: '/viewfeedbackcommon/4074' })
      // window.open(routeData.href, '_blank')
      this.openFeedBack(id)
    },
    openFeedBack (id) {
      // router.push({ path: '/viewfeedbackcommon_v3/' + id + '/web' })
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      axios
        .get(BaseURLV3 + '/org/' + id + '/scheduleid', config)
        .then(response => {
          if (response.data.success) {
            // this.candidateListing = response.data.shortlisted_candidate
            var routeData = router.resolve({ path: '/viewfeedbackcommon_v3/' + response.data.schedule.id + '/web' })
            window.open(routeData.href, '_blank')
          } else {

          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    setSchedule (data) {
      // this.scheduleId = data._id
      // this.postId = data.post_id
      // var scheduleDate = moment(data.start_datetime).utc().format('yyyy-MM-DD')
      // var scheduleStartTime = moment(data.start_datetime).utc().format('HH:mm:ss')
      // var scheduleEndTime = moment(data.start_datetime).utc().add(1, 'hours').format('HH:mm:ss')
      // var startDatetime = moment(data.start_datetime).utc().format('yyyy-MM-DD HH:mm:ss')
      // var endDatetime = moment(data.start_datetime).utc().add(1, 'hours').format('yyyy-MM-DD HH:mm:ss')
      // for (let i = 0; i < timezoneList.length; i++) {
      //   if (timezoneList[i].fullName === this.timezone) {
      //     this.timezonetype = timezoneList[i].name
      //   }
      // }
      // var formData = {}
      // this.mainurl = '/dashboard/add_schedule_availability'
      // formData = {
      //   post_id: this.postId,
      //   schedule_id: this.scheduleId,
      //   schedule_date: scheduleDate,
      //   schedule_end_time: scheduleEndTime,
      //   schedule_start_time: scheduleStartTime,
      //   start_datetime: startDatetime,
      //   end_datetime: endDatetime,
      //   schedule_org_timezone: this.timezonetype,
      //   schedule_candidate_timezone: '',
      //   schedule_timezone: this.timezonetype
      // }
      // axios.post(BaseURLV3 + this.mainurl, {
      //   formData: formData
      // }, this.config).then(response => {
      //   if (response.data.message === 'success') {
      //     this.$awn.success('Success ')
      //   } else if (response.data.message === 'already scheduled') {
      //     this.$awn.alert('The selected Panels are already blocked for the same timing. Please choose different panels', optionsOverrides1)
      //   } else {
      //     this.$awn.success(response.data.message)
      //   }
      //   this.candidateList()
      // }).catch(e => {
      //   console.log(e)
      // })
    },
    setAvailability () {
      if (this.availability === '') {
        this.$awn.alert('Select Date ', optionsOverrides1)
        return
      }
      if (this.setAvailabilityType === 'reschedule' && this.reScheduleReason === '') {
        this.$awn.alert('Select Reason ', optionsOverrides1)
        return
      }
      if (this.setAvailabilityType === 'reschedule') {
        var a = moment(this.selectedAvailableTime).utc().tz(this.timezone).format('YYYYMMDDHHmm')
        var b = moment(this.availability).format('YYYYMMDDHHmm')
        if (a === b) {
          this.$awn.alert('Choose different date and time. ', optionsOverrides1)
          return
        }
      }
      var startDatetime = moment(this.availability).format('yyyy-MM-DD HH:mm:ss')
      // var endDatetime = moment(this.availability).add(1, 'hours').format('yyyy-MM-DD HH:mm:ss')
      for (let i = 0; i < timezoneList.length; i++) {
        if (timezoneList[i].fullName === this.timezone) {
          this.timezonetype = timezoneList[i].name
        }
      }
      var formData = {}
      if (this.setAvailabilityType === 'resch') {
        this.mainurl = '/org/' + this.scheduleId + '/reschedule'
        formData = {
          available_datetime: startDatetime,
          tz: this.candidateTimezone
        }
      } else if (this.setAvailabilityType === 'reschedule') {
        this.mainurl = '/org/' + this.scheduleId + '/id_reschedule'
        formData = {
          available_datetime: startDatetime,
          cancel_reason_id: this.reScheduleReason.id,
          cancel_reason: this.reScheduleComments,
          tz: this.candidateTimezone
        }
      } else {
        this.mainurl = '/org/' + this.scheduleId + '/set_availability'
        formData = {
          available_datetime: startDatetime,
          tz: this.candidateTimezone
        }
      }
      // formData = {
      //   available_datetime: startDatetime
      // }
      this.disableSetAvailabilityButton = true
      axios.post(BaseURLV3 + this.mainurl, formData, this.config).then(response => {
        $('#setAvailability').modal('hide')
        this.disableSetAvailabilityButton = false
        if (response.data.success) {
          this.$awn.success(response.data.msg)
          this.getPostDetailsId()
        } else {
          this.$awn.alert(response.data.msg, optionsOverrides1)
          this.getPostDetailsId()
        }
      }).catch(e => {
        this.disableSetAvailabilityButton = false
        console.log(e)
      })
    },
    showReason1 (sid) {
      localStorage.setItem('sid', JSON.stringify(sid))
      this.reasonOpen = true
    },
    UploadCandidateResume (k) {
      this.uploadCandidateResume = true
      this.user_id = localStorage.getItem('_id')
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      this.resumeBtnDisabled = true
      const formData = new FormData()
      formData.append('tz', this.timezone)
      for (let k = 0; k < this.resumefiles.length; k++) {
        formData.append('resume', this.resumefiles[k])
      }
      // formData.append('post_id', this.$route.params.id)
      // formData.append('org_id', this.userInfo._id)
      // formData.append('schedule_org_timezone', this.timezonetype)
      // formData.append('schedule_timezone', this.timezonetype)
      axios.post(BaseURLV3 + '/org/' + this.$route.params.post_id + '/candidate_resume', formData, config)
        .then(response => {
          if (response.data.success) {
            this.resumeResponse = response.data.message
            this.$awn.success('Candidate Resume uploaded successfully ')
            $('#uploadResume').modal('hide')
            // this.candidateList()
            this.getPostDetailsId()
          } else {
            this.$awn.alert(response.data.msg, optionsOverrides1)
          }
          this.resumeBtnDisabled = false
          this.isLoading = false
        }, config)
        .catch(e => {
          console.log(e)
        })
    },
    showShedule1 (scheduleData) {
      localStorage.setItem('scheduleData', JSON.stringify(scheduleData))
      localStorage.setItem('postData', JSON.stringify(this.postData))
      localStorage.setItem('postId', JSON.stringify(this.$route.params.id))
      this.sheduleOpen = true
    },
    // getTime (date) {
    //   const Start = momentsone.utc(date).tz(this.timezone).format('hh:mm a')
    //   return Start
    // },
    // getDate (date) {
    //   const Start = momentsone.utc(date).tz(this.timezone).format('DD MMM yyyy')
    //   return Start
    // },
    showPanels (id) {
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.get(BaseURLV3 + '/org/' + id + '/select_interviewer', config)
        .then(response => {
          this.interviewersListErrorMsg = ''
          this.interviewersList = response.data.selected_interviewer
          this.showInterviewersListModal = true
          if (this.interviewersList.length === 0) {
            this.interviewersListErrorMsg = 'The selected panels are already blocked for the same timing .please choose different panels.'
          }
        }, config)
        .catch(e => {
          console.log(e)
        })
    },
    onClose () {
      this.showInterviewersListModal = false
      this.viewHistoryModel = false
    }
    // viewFeedback (data) {
    //   this.id = data._id
    //   this.orgName = data.organization
    //   this.orgEmail = data.user_email
    //   var email = this.orgEmail
    //   var sp = email.split('@')
    //   let routerPage = ''
    //   if (sp[1] === 'acsicorp.com') {
    //     routerPage = this.$router.resolve('/new_Feedback/' + this.id)
    //   } else {
    //     routerPage = this.$router.resolve('/viewfeedbackcommon/' + this.id)
    //   }
    //   window.open(routerPage.href, '_blank')
    // }
    // submitFeedback (data) {
    //   this.id = data._id
    //   this.orgName = data.organization
    //   this.orgEmail = data.user_email
    //   var email = this.orgEmail
    //   var sp = email.split('@')
    //   let routerPage = ''
    //   if (sp[1] === 'acsicorp.com') {
    //     routerPage = this.$router.resolve('/addfeedback/' + this.id)
    //   } else {
    //     routerPage = this.$router.resolve('/addfeedbackcommon/' + this.id)
    //   }
    //   window.open(routerPage.href, '_blank')
    // }
  }
}
</script>

<style lang="scss" scoped>
.Orgimage {
  width: 3rem;
  height: 3rem;
}
.postArea {
  background: #f5f5f5;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 10px;
  //   border: solid 2px #80808030;
  border-radius: 5px;
}
.postArea1 {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
  border-left: 3px solid #f5f5f5;
  width: 100%;
  display: grid;
  grid-template-columns: 30% 39% 30%;
  align-items: center;
}
.postArea1:hover {
  border-left: 3px solid #5bad2b;
}

.postArea2 {
  background: #f5f5f5;
  padding: 2px;
  border-radius: 5px;
  border-left: 3px solid #f5f5f5;
  width: 100%;
  display: grid;
  grid-template-columns: 30% 39% 30%;
  align-items: center;
}
.postArea2:hover {
  border-left: 3px solid #5bad2b;
}
.warningBorder {
  border: #fad475;
  border-width: 1px;
  border-style: solid;
  box-shadow: 1px 1px 3px 0.2px #fad475;
}
.dangerBorder {
  border: rgb(255, 0, 0);
  border-width: 1px;
  border-style: solid;
  box-shadow: 1px 1px 3px 0.2px rgb(248, 140, 94);
}
.maincontent {
  margin: 10px 4% 4%;
  background-color: white;
  padding: 10px;
  min-height: 450px;
}
.myIcons {
  padding-top: 5px;
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  // display: flex;
  // flex-direction: row;
  justify-content: flex-end;
}
.icon1 {
  grid-column: 5/6;
  padding: 10px;
  text-align: center;
  cursor: pointer;
}
.icon2 {
  grid-column: 6/7;
  padding: 10px;
  text-align: center;
  cursor: pointer;
}
.icon1 > .fa-user-o {
  font-size: 25px;
  color: #5bad2b;
}
.icon2 > .fa-cloud-upload {
  font-size: 25px;
  color: #5bad2b;
}
.iconName {
  font: 10px;
  color: black;
}
.round {
  width: 70px;
  height: 70px;
  // border: 1px solid #5bad2b;
  border-radius: 50%;
  padding: 7px;
}
.uniqueId {
  display: flex;
  text-align: start;
}
.validity {
  // align-content: right;
  text-align: end;
  display: flex;
  flex-direction: column;
  row-gap: 6px;
}
.position {
  display: flex;
  text-align: start;
  flex-direction: column;
}
.candidateArea {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.canName {
  font-size: 18px;
  font-weight: bold;
}
.candidateDetails {
  text-align: start;
}
.availability1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 6px;
  align-items: flex-end;
}
.countStyle {
  font-size: 2.5rem !important;
}
.countSpecificationStyle {
  font-size: 1.3rem !important;
}
a {
  color: #333;
}
.modalClose {
  display: flex;
  justify-content: center;
}
.AvailabilityPopup {
  width: 60%;
  // height: 200px;
}
.filterTopclass {
  list-style: none;
  // margin: 10px;
  display: flex;
  flex-direction: column;
  row-gap: 2px;
}
.filterListclass {
  padding: 4px 10px 0px 10px;
  // border-bottom: 0.5px solid rgb(249, 248, 248);
}
// .filterListclass:hover {
//   // color: #5bad2b;
//   // background-color: rgb(246, 243, 243);
// }
.activeFilterclass {
  background-color: #5bad2b;
}
.activeFilterclass:hover {
  background-color: #5bad2b;
}
.activeFiltertext {
  color: white;
}
.filterDivclass {
  background-color: white;
  padding: 10px;
}
.profileClass {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}
.statusName {
  font-size: 1.6rem !important;
  font-weight: 600;
}
div.searchinput input[type=text] {
  padding: 10px;
  font-size: 14px;
  border-right: none;
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
  border-left: 1px solid lightgrey;
  float: left;
  width: 300px;
  outline: none;
}

div.searchinput button {
  float: left;
  width: 50px;
  padding: 10px;
  background: #5bad2b;
  color: white;
  font-size: 14px;
  border: 1px solid grey;
  border-left: none;
  cursor: pointer;
}
div.searchinput span {
  float: left;
  width: 30px;
  padding: 10px;
  // background: #5bad2b;
  color: rgb(123, 117, 117);
  font-size: 14px;
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
  border-left: none;
  border-right: none;
  cursor: pointer;
}
div.searchinput button:hover {
  background: green;
}

div.searchinput::after {
  content: "";
  clear: both;
  display: table;
}
.filterdata {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 10px;
}
.postArea:hover {
  border-left: #5bad2b;
}
.filterBoxBorder {
  border: 1px solid rgb(237, 234, 234);
  background-color: #f5f5f5;
  padding-bottom: 8px;
}
.filterbyClass {
  background-color: #f5f5f5;
}
.btncolorClass {
  color: #5bad2b;
}
.badge {
  position: relative;
  top: -18px;
  left: -5px;
  // border: 0.4px solid black;
  border-radius: 50%;
  background-color: white;
  color: black;
  font-size: 14px;
  padding: 1px;
}
.fw-600 {
  font-weight: 600;
}
.resume{
  width: 100px;
  height: 100px;
}
.Orgimage1 {
  border-radius: 50%;
}
.buttonStyle {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  column-gap: 7px;
}
.paginationClass {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.pagination {
  border-radius: 0px !important;
}
.active a.page-link {
  background-color: #5bad2b;
  border-color: #5bad2b;
}
.active a.page-link:hover {
  background-color: #5bad2b;
  border-color: #5bad2b;
}

.logmenu .menu {
    padding: 10px !important;
    color: #444;
}
.menu:hover {
    padding: 10px !important;
    color: #444;
    border-left: 3px solid #60AB2F;
}
.isSelected {
  background-color: transparent;
  border: none;
  color: #5bad2b;
}
// .countcard{
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   align-content:center ;
//   width: 100px;
//   height: 100px;
//   color: #5bad2b;
//   // background-color: white;
// }
</style>
